import React, {useEffect, useState} from 'react';
import Cookies from "js-cookie";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText} from "@material-ui/core";
import {toast, ToastContainer} from "react-toastify";
import api from "../../api";
import LoadingSpinner from "../Loading";
import {getMyInfo} from "../../auth";
import Logo from "../../assets/images/logo2-removebg-preview.png";
import Drawer from "./Drawer";
import {e2p, getRoleTitle} from "../../utils/utils";
import {CiWallet} from "react-icons/ci";
import ChargeModal from "../ChargeModal";


const MyAppBar = () => {
    const [open, setOpen] = useState(false);
    const [myInfo, setMyInfo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [chargeModalOpen, setChargeModalOpen] = useState(false);
    
    useEffect(() => {
        async function fetchMyData() {
            try {
                const myInfoData = await getMyInfo();
                setMyInfo(myInfoData.data.data);
                setLoading(false);
            } catch (error) {
                console.log(error);
            }
        }
        
        fetchMyData();
    }, []);
    
    function handleLogout() {
        api.post('/logout')
            .then(res => {
                toast.success(res.data.message);
                setTimeout(() => {
                    Cookies.remove('token');
                    window.location.href = '/login';
                }, 1000);
            })
            .catch(error => {
                // console.log(error);
                // toast.error(error.data);
            });
    }
    
    const handleOpenDialog = () => {
        setOpen(true);
    };
    
    const handleCloseDialog = () => {
        setOpen(false);
    };
    
    const handleLogoutConfirm = () => {
        handleLogout();
        setOpen(false);
    };
    
    const handleOpenChargeModal = () => {
        setChargeModalOpen(true);
    }
    
    return (
        <div className="w-100">
            {loading ? <LoadingSpinner/> :
                <div className="container">
                    <nav className="navbar rounded-3 shadow mt-3 justify-content-between"
                         style={{backgroundColor: 'var(--header-color)', height: '5rem'}}>
                        <div className="d-flex justify-content-start w-auto">
                            <Drawer/>
                            {myInfo &&
                                <>
                                    {myInfo.role !== 'admin' &&
                                        <div className="w-100 cursor-pointer rounded-2 d-flex px-3 gap-1"
                                             onClick={handleOpenChargeModal}
                                             style={{backgroundColor: 'white'}}>
                                            {/*<CiWallet size={30} className="my-auto mx-1"/>*/}
                                            <p className="my-auto">
                                                <span className="fw-bold text-nowrap">شارژ</span>
                                            </p>
                                            <p className="my-auto">
                                        <span
                                            className="fw-bold text-nowrap">{e2p(myInfo?.company?.wallet?.balance.toLocaleString())} ریال</span>
                                            </p>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                        <div className="d-none d-sm-block d-md-block d-lg-block justify-content-end ms-3">
                            <a className="d-flex" href="/user-panel" style={{left: 0}}>
                                <p className="my-auto fw-bold fs-6 text-dark me-1">صــــاف یـــــار</p>
                                <div className="align-text-center" style={{height: '3rem'}}>
                                    <img src={Logo} alt="logo" className="w-auto"
                                         style={{minWidth: '100%', maxHeight: '100%'}}/>
                                </div>
                            </a>
                        </div>
                    </nav>
                    {myInfo && <div className='container pt-4 pv-4'>
                        <div className='row gap-3'>
                            <div className="col">
                                <span className="text-muted fw-light">
                                    سلام <b>({myInfo.user.username})</b> خوش آمدید
                                </span>
                                <small
                                    className="text-muted"> [{myInfo.company?.company} / {getRoleTitle(myInfo.role)}]</small>
                            </div>
                            <div className="card bg-danger col-auto rounded-2 cursor-pointer text-white"
                                 style={{width: '70px', height: '40px'}}
                                 onClick={handleOpenDialog}>
                                <span className="my-auto mx-auto">خروج</span>
                            </div>
                        </div>
                    </div>
                    }
                    <ChargeModal
                        isOpen={chargeModalOpen}
                        onClose={() => setChargeModalOpen(false)}
                        url={'/wallet/zibal/payment'}
                    />
                    <Dialog open={open} onClose={handleCloseDialog}>
                        <DialogContent>
                            <DialogContentText>مطمئن هستید که میخواهید خارج شوید ؟</DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleLogoutConfirm} className='btn btn-primary me-1'>
                                خروج
                            </Button>
                            <Button onClick={handleCloseDialog} className='btn btn-secondary'>
                                انصراف
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            }
        </div>
    );
};

export default MyAppBar;
